var _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReady(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 15.3125C18.7574 15.3125 17.75 16.3199 17.75 17.5625C17.75 18.8051 18.7574 19.8125 20 19.8125C21.2426 19.8125 22.25 18.8051 22.25 17.5625C22.25 16.3199 21.2426 15.3125 20 15.3125ZM18.875 17.5625C18.875 16.9412 19.3787 16.4375 20 16.4375C20.6213 16.4375 21.125 16.9412 21.125 17.5625C21.125 18.1838 20.6213 18.6875 20 18.6875C19.3787 18.6875 18.875 18.1838 18.875 17.5625Z",
    fill: "#7E57C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 28.625H22.8125C23.1232 28.625 23.375 28.3732 23.375 28.0625C23.375 27.7518 23.1232 27.5 22.8125 27.5H20.7819C21.4929 26.5072 22.1836 25.617 22.8231 24.7928C24.8586 22.1693 26.375 20.2149 26.375 17.75C26.375 14.2292 23.5208 11.375 20 11.375C16.4792 11.375 13.625 14.2292 13.625 17.75C13.625 20.2149 15.1414 22.1693 17.1769 24.7928C17.8164 25.617 18.5071 26.5072 19.2181 27.5H17C16.6893 27.5 16.4375 27.7518 16.4375 28.0625C16.4375 28.3732 16.6893 28.625 17 28.625ZM23.5003 22.029C24.6461 20.4129 25.25 19.1522 25.25 17.75C25.25 14.8505 22.8995 12.5 20 12.5C17.1005 12.5 14.75 14.8505 14.75 17.75C14.75 19.1522 15.3539 20.4129 16.4997 22.029C16.958 22.6753 17.4783 23.3459 18.0582 24.0933L18.0586 24.0939C18.2053 24.2829 18.3557 24.4769 18.51 24.6766C18.9837 25.2899 19.4849 25.9475 20 26.6604C20.5151 25.9475 21.0163 25.2899 21.49 24.6766C21.6443 24.4769 21.7947 24.2829 21.9414 24.0939L21.9418 24.0934C22.5217 23.3459 23.042 22.6753 23.5003 22.029V22.029Z",
    fill: "#7E57C2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#7E57C2",
    strokeOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReady);
export default __webpack_public_path__ + "static/media/Ready.deac8b6b5328428c2194e82cf8680e6f.svg";
export { ForwardRef as ReactComponent };